import type { ProviderOperationsAction } from "libs/apiClient";

/** These operations change the whole game, so only one may run per game and other rows of the game need fresh available actions. */
const GAME_SCOPED_ACTIONS: ProviderOperationsAction[] = ["process_pending", "sync"];

export function isGameScopedAction(action: ProviderOperationsAction): boolean {
	return GAME_SCOPED_ACTIONS.includes(action);
}
